import React from 'react';

export const CandidateHeaderSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col lg:flex-row items-start lg:items-end justify-between gap-4 rounded-lg border border-solid border-neutral-border bg-default-background p-4 lg:pl-4 lg:pr-6 lg:py-4 shadow-sm flex-wrap overflow-hidden">
      {/* Left Section: Avatar, Name, Role, Location */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full lg:w-auto">
        {/* Avatar */}
        <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse flex-shrink-0"></div>

        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-4 lg:gap-6 w-full min-w-0">
          {/* Name and Role Section */}
          <div className="flex flex-col items-start gap-1">
            {/* Name */}
            <div className="h-8 bg-gray-200 rounded animate-pulse w-48"></div>
            {/* Role */}
            <div className="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
            {/* Location */}
            <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
          </div>

          {/* Middle Section: Contact Details */}
          <div className="flex flex-col md:flex-row items-start gap-4 w-full lg:w-auto min-w-0 overflow-hidden">
            {/* Column 1: Date of Birth, Time */}
            <div className="flex flex-col items-start gap-1">
              {/* Date of Birth with icon */}
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              </div>
              {/* Time/Duration with icon */}
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              </div>
            </div>

            {/* Column 2: Phone, Email */}
            <div className="flex flex-col items-start gap-1">
              {/* Phone with icon */}
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-28"></div>
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>
              {/* Email with icon and copy button */}
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-36"></div>
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
